import Reveal from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What should I wear to my appointment?",
    a: "Whatever is comfortable. Most treatments are done with professional draping — you'll be covered except for the area being worked on. For sports massage, athletic shorts and a tank top work well.",
  },
  {
    q: "Does insurance cover massage therapy?",
    a: "Most extended health plans in BC cover treatment by a Registered Massage Therapist, typically 80–100% up to an annual maximum. Check your plan for a per-visit cap or whether a doctor's referral is required.",
  },
  {
    q: "Do you offer direct billing?",
    a: "Yes — I bill directly to Pacific Blue Cross, Manulife, Sun Life, Canada Life, Green Shield and most other major insurers, so you only pay any remaining balance at your visit.",
  },
  {
    q: "I have an ICBC or WorkSafeBC claim. Am I covered?",
    a: "Yes — ICBC covers 12 pre-authorized RMT sessions within 12 weeks of your accident date, and WorkSafeBC covers approved claims. I don't bill them directly, so you'll pay at your visit and submit your receipt for reimbursement yourself. Bring your claim number to your first visit.",
  },
  {
    q: "What happens at my first visit?",
    a: "We start with a short health-history intake and assessment, discuss your goals, then move into treatment. Plan for the full appointment time — nothing is rushed.",
  },
  {
    q: "What is your cancellation policy?",
    a: "Life happens — I ask for 24 hours notice so the spot can go to someone on the waitlist. Late cancellations may be charged 50–100% of the session fee.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-sand/40 py-24 lg:py-32">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-clay">
              <span className="h-px w-10 bg-clay" /> FAQ
            </p>
            <h2 className="font-serif text-4xl font-light leading-tight tracking-tighter text-forest sm:text-5xl" data-testid="faq-heading">
              Everything you're wondering, answered.
            </h2>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-forest/60">
              Something else on your mind? Call or email — I reply within one business day.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-7 lg:col-start-6">
          <Reveal delay={0.15}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-b border-forest/15" data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="py-6 text-left font-serif text-xl font-light text-forest hover:no-underline lg:text-2xl" data-testid={`faq-question-${i}`}>
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="max-w-2xl pb-6 text-sm leading-relaxed text-forest/70 lg:text-base" data-testid={`faq-answer-${i}`}>
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
